import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Config from "../Config";
import { useAuthHandling } from "../useAuthhandling";
import Toastmodal from "../Toastmodal";
import Cookies from "js-cookie";
import Deletemodal from "../Deletemodal";
import { Link } from "react-router-dom";
import Nodatafound from "../Nodatafound";

function Bannerlist() {
  const [bannerdata, setBannerdata] = useState([]);
  const { isAuthorized, handleUnauthorized } = useAuthHandling();
  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);
  const [bannertype, setBannertype] = useState('');
  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/banner/get-banners`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const data = await res.json();
    if (res.status === 404 || !data) {
      alert("error");
    } else {
      setBannerdata(data.data);
    }
  };
  useEffect(() => {
    getinfo();
  }, []);


  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);
    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/banner/delete-banner/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (response.status === 200) {
      setToastmodal(true);
      setToastmessage("Sucessfully Deleted");
      setToasttype("success");
      setToastlarge(false);
      getinfo ()
       } 
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData(id);
    }
    else {
      const deletedata = await response.json();
      setToastmodal(true);
      setToastmessage(response.message);
      setToasttype("error");
      setToastlarge(true);
    }
  };

  const Typeselect = async () => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/banner/home-settings`, {
      method: "POST",
      headers: { Authorization: `Bearer ${Cookies.get("a_token")}`,
      "Content-Type": "application/json" 
    },
    body: JSON.stringify({
      bannerType:bannertype
    }),
    });


    if (res.status === 200 ) {
      const deletedata = await res.json();

      setToastmodal(true);
      setToastmessage("Sucessfully Updated home page type");
      setToasttype("success");
      setToastlarge(false);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      Typeselect();
    }
    else {
     console.log("error");
    }
  };
  return (
    <div>
      <div className="container-scroller">
        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row grid-margin">

              <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Select banner type for home page</h4>
                     
                        <div className="table-responsive pt-3">
                          <div className="jsgrid-grid-header jsgrid-header-scrollbar">
                            <table className="table table-bordered banner_type">
                              <thead>
                                <tr>
                                  <th>Type</th>
                                  <th>

                                    <select className="form-select" onChange={(e)=>setBannertype(e.target.value)} value={bannertype}>
                                      <option> Select type</option>
                                      <option value='image'>Image</option>
                                      <option value='video'>Video</option>
                                    </select>
                                  </th>
                                  <th><button className="banner_type_btn_submit" onClick={Typeselect}>Save</button></th>
                                </tr>
                              </thead>
                             
                            </table>
                          </div>
                        </div>
                     
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Banner List</h4>
                      <div
                        id="js-grid"
                        className="pt-3 jsgrid"
                        style={{
                          position: "relative",
                          height: 516,
                          width: "100%",
                        }}
                      >
                        <div className="table-responsive pt-3">
                        {bannerdata?.length>0?
                          <div className="jsgrid-grid-header jsgrid-header-scrollbar">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Sl.No</th>
                                  <th>Title</th>
                                  <th>Type</th>
                                  <th>Image</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {bannerdata.map((element, i) => {
                                  return (
                                    <>
                                      <tr>
                                        <th scope="row">{i + 1}</th>
                                        <td>{element.title}</td>
                                        <td>{element.fileType}</td>
                                        {element.fileType==='image'?
                                       <td><img src={element.fileUploadPath} width="50" /></td>
                                       :
                                       <td> <video
                                       className="video-slide active"
                                       src={element.fileUploadPath}
                                       autoPlay
                                       muted
                                       loop
                                       width="100"
                                       height="100"
                                     ></video></td>
                                  }
                                        <td className="actions_td">
                                          <Link
                                          to="#"
                                          className="action_icons"
                                             onClick={() => tog_animationFlip(element._id)}
                                          >
                                            <i className="fa-solid fa-trash" />
                                          </Link>
                                         
                                            <Link to={"/editbanner/" + element._id}  className="action_icons">
                                        
                                            <i className="fa-solid fa-pen" />
                                            </Link>
                                        
                                         
                                             <Link to={"/bannerview/" + element._id}  className="action_icons">
                                            <i className="fa-solid fa-eye" />
                                            </Link>
                                          
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                          :
                          <Nodatafound/>
                        }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}


    {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Banner"}
          />
        ) : (
          ""
        )}
    </div>
  );
}

export default Bannerlist;
